import classNames from 'classnames';
import React from 'react';
import { Size } from '../../../constants/commonEnums';

interface LoaderProps {
  loaderUrl?: string;
  size?: Size;
  className?: string;
  loadingLabel?: string;
}

const SIZEMAP: Record<Size, string> = {
  [Size.XSMALL]: '2',
  [Size.SMALL]: '4',
  [Size.LARGE]: '12',
  [Size.MEDIUM]: '8',
  [Size.XLARGE]: '16',
};

const Loader: React.FC<LoaderProps> = ({
  loaderUrl = '',
  size = Size.MEDIUM,
  className = '',
  loadingLabel = '',
}) => {
  const loaderClasses = classNames({
    [`w-${SIZEMAP[size]}`]: true,
    [`h-${SIZEMAP[size]}`]: true,
    ['loader-svg-icon']: !loaderUrl,
  });

  const getLoaderIcon = () => {
    return loaderUrl ? (
      <img src={loaderUrl} alt="loader-icon" className={loaderClasses} />
    ) : (
      <svg
        className={loaderClasses}
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          cx="33"
          cy="33"
          r="30"
        />
      </svg>
    );
  };

  return (
    <div
      className={`flex flex-col items-center justify-center w-fit ${className}`}
    >
      {getLoaderIcon()}
      {loadingLabel}
    </div>
  );
};
export { Loader };
